import { Head, Link } from '@inertiajs/react';
import { LoginForm } from './components/LoginForm';

export default function Login() {
  return (
    <>
      <Head title="Login - Project SHORT" />
      <div className="grid h-full">
        <div className="flex flex-col items-center justify-center px-6">
          <div className="flex flex-col w-full max-w-lg gap-5 text-center">
            <LoginForm />
            <div className="text-sm text-center">
              Don't have an account?{' '}
              <Link
                href="/registration/new"
                className="underline underline-offset-4"
              >
                Sign up
              </Link>
            </div>
            <p className="text-sm">
              <Link
                href={`/email_verification/new`}
                className="underline underline-offset-4"
              >
                Resend verification email
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
